import React from 'react';
import { Star } from 'lucide-react';
export function SocialProof() {
  return;
}